/**
 * Converts provided object into a query string and handles some of the ZAPI quirks.
 *
 * @param {object} data
 * @returns {string}
 */
export const serialize = (data) => {
    return Object.entries(data).map(([key, value]) => {
        if (typeof value === 'boolean') {
            // ZAPI requires all boolean values to be provided as "True" | "False"
            // string literals.
            value = value ? 'True' : 'False';
        } else if (Array.isArray(value)) {
            // ZAPI requires all lists to be defined as a string with
            // comma-separated values.
            value = value.join(',');
        }

        value = key + '=' + encodeURIComponent(value);

        return value;
    }).join('&');
};
